export default {
  buttons: {
    remove: 'Fjern',
  },
  title: 'Rabatkode eller gavekort',
};
